import styled from 'styled-components'

import { CostSummaryStyled } from '@webapp/core/components/CostSummary/styles/CostSummaryStyled'

interface IOrderItemTooltipStyledProps {}

export const OrderItemTooltipStyled = styled.div<IOrderItemTooltipStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  ${CostSummaryStyled} {
    font-size: ${(props) => props.theme.typography.pxToRem(14)};
  }
`
